var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TextEditor',{attrs:{"entity":_vm.form,"label":"Navn","alias":"5d139c4a0512d063ecf457fe","validate":true,"scope":"productspec"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }